// extracted by mini-css-extract-plugin
export default {"expandLevel1Icon":"ExpandableIcons_expandLevel1Icon__hiAhk"};